import React from "react";
import "../styles/user-settings.css";

export const UserSettings = () => {
  return (
    <>
      <div className="title-container">
        <h1 className="s48px">Your Profile</h1>
      </div>
      <div className="main-grid">
        <div className="sidebar">
          <h2 className="s24px-white">Account Settings</h2>
          <h2 className="s24px-white">Manage Social Media Accounts</h2>
          <h2 className="s24px-white">..........</h2>
          <div className="logout-container">
            <h2 className="s24px-white">Logout</h2>
          </div>
        </div>
        <div className="details-container">
          <div className="details s18px white">Account Details</div>
          <div className="detail s14px">
            <strong>Account User Name</strong> <br></br>
            John Smith
          </div>
          <div className="detail s14px">
            <strong>Account Email</strong> <br></br>
            johnsmith@gmail.com
          </div>
          <div className="detail s14px">
            <strong>Account User Birthday</strong> <br></br>
            04/11/1999
          </div>
          <div className="space"></div>
          <div className="details s18px white">Social Media Digest</div>
          <div className="detail s14px">
            <strong>Frequency of updates</strong> <br></br>
            Select how often you wish to receive a digest <br></br>
            <select name="frequency" id="frequency" className="frequency">
              <option value="daily">Daily</option>
              <option value="bi-day">Once every two days</option>
              <option value="weekly">Once per week</option>
            </select>
          </div>
        </div>
      </div>
    </>
  );
};
